import { Routes, Route } from "react-router";
import {
  Checkout,
  Favorites,
  MyReviews,
  Orders,
  NotFoundPage,
  Products,
  SingleProduct,
  Profile,
  ResetPassword,
} from "../pages";
import RolesHelper from "../common/services/permissions/RolesHelper";
import { ProtectedRoute } from "../components";

export default function AppRoutes() {
  const pageVisible = RolesHelper?.getPagesVisibility();

  return (
    <Routes>
      <Route path="/" element={<Products />} />
      <Route path="login" element={<Products />} />
      <Route
        path="favorites"
        element={
          <ProtectedRoute visible={pageVisible?.is_favorites_visible}>
            <Favorites />
          </ProtectedRoute>
        }
      />
      <Route
        path="reviews"
        element={
          <ProtectedRoute visible={pageVisible?.is_reviews_visible}>
            <MyReviews />
          </ProtectedRoute>
        }
      />
      <Route
        path="orders"
        element={
          <ProtectedRoute visible={pageVisible?.is_orders_visible}>
            <Orders />
          </ProtectedRoute>
        }
      />
      <Route path="product/:productId" element={<SingleProduct />} />
      <Route path="checkout" element={<Checkout />} />
      <Route
        path="profile"
        element={
          <ProtectedRoute visible={pageVisible?.is_profile_visible}>
            <Profile />
          </ProtectedRoute>
        }
      />
      <Route
        path="password_reset/:user_id/:token"
        element={<ResetPassword />}
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
